import * as React from 'react';
import { SVGProps } from 'react';

const SvgDoctorOfficee = (props: SVGProps<SVGSVGElement>) => (
  <svg width={150} height={150} viewBox="0 0 150 150" fill="none" role="img" {...props}>
    <path
      d="M75 150c33.137 0 60-26.863 60-60s-26.863-60-60-60-60 26.863-60 60 26.863 60 60 60Z"
      fill="#EAEAF0"
    />
    <path
      d="m64 42.78.67-14.437L78.416 27l5.365 1.343 6.37 8.73-4.024 10.408-9.387 4.029-9.387-2.35L64 42.78Z"
      fill="#fff"
    />
    <path
      d="m92.065 66.448-1.192-5.58c-1.193-5.58-5.887-6.579-5.887-6.579l-1.695-.17c-6.434 3.979-12.92.538-12.92.538C64.885 55.064 63.41 56 62.5 59c-.908 3-3.5 17-3.5 17l13.722 1h19.869v-3.204l-.526-7.348ZM62.58 37.157s-1.59-10.906 3.792-12.633c0 0 1.59-.53 2.14-1.423 1.027-1.491 2.917-3.019 7.899-3.208 4.93-.23 10.87 1.818 13.503 9.134l1.819 2.2-.628 5.67-2.816-2.619-3.472-4.71-12.439-1.626-5.737-.22-1.96 9.83-2.1-.395Z"
      fill="#FF4496"
    />
    <path
      d="M93.188 78.17c-.31-.24-.584-.629-.624-1.102-.008-.094-1.336-12.442-1.913-18.725-.457-4.865-7.615-5.016-7.667-5.056-.918-.004-1.613-.808-1.546-1.728.068-.92.922-1.674 1.84-1.67.095-.015 2.466.054 4.953.919 3.54 1.327 5.574 3.7 5.844 6.915.577 6.284 1.861 18.686 1.87 18.781.079.946-.62 1.82-1.53 1.91a1.387 1.387 0 0 1-1.227-.243Z"
      fill="currentColor"
    />
    <path
      d="M66.782 51.514c-3.545-2.745-5.691-7.132-5.482-12.07.04-.672.087-1.251.221-1.938l3.34.3c-.055.484-.154 1.023-.115 1.493-.256 6.66 4.95 12.008 11.609 11.8 6.66-.208 12.386-5.797 12.643-12.457-.008-.094.027-.242.02-.336l3.394-.185c-.035.148.024.282-.011.43-.178 4.17-1.964 8.063-4.976 11.095-3.011 3.032-7.003 4.69-11.121 4.842-3.731.19-6.953-.986-9.522-2.974Z"
      fill="currentColor"
    />
    <path
      d="M70.316 46.625c-.771-.597-.858-1.633-.25-2.393.61-.76 1.654-.92 2.374-.362.154.12 3.745 2.811 8.242-.306.771-.547 1.796-.37 2.29.365.494.734.245 1.773-.526 2.32-5.165 3.744-10.176 1.888-12.13.376ZM55.244 78.104c-.454-.353-.688-.88-.548-1.466-.008-.092 1.977-12.417 3.013-18.632.53-3.227 2.733-5.677 6.293-7.16 2.463-1.034 4.81-1.205 4.904-1.22.94-.05 1.655.593 1.64 1.534-.015.941-.706 1.705-1.647 1.754-.093.015-7.084.567-7.906 5.388-1.036 6.216-3.02 18.54-3.064 18.593-.159.917-1.002 1.562-1.907 1.466-.237-.01-.525-.06-.778-.257Z"
      fill="currentColor"
    />
    <path
      d="M62.178 45.442c-.206-.159-.316-.332-.478-.545-1.877-4.085-2.855-8.877-2.922-9.104-.016-.188-1.136-5.529.816-10.246 1.6-3.76 4.034-5.035 5.343-5.425 1.12-1.502 3.454-4.52 10.809-5.405 8.628-1.128 13.613 4.573 13.826 4.825l.102.08c6.807 9.128 2.158 20.53 2.008 21.028-.315.808-1.143 1.22-1.968 1.108-.78-.166-1.317-.844-1.242-1.663.154-2.162-.39-2.934-1.384-4.493-.552-.866-1.156-1.772-1.747-3.107-1.124-2.536-5.493-2.06-5.493-2.06l-.284.044c-6.065-.309-9.532-1.062-11.409-1.726-2.26 5.62-3.08 15.248-3.071 15.342-.032.765-.647 1.43-1.396 1.639-.62.047-1.152-.014-1.51-.292Zm23.458-24.823c-1.692-1.31-5.063-3.218-9.614-2.618-6.022.777-7.568 2.914-8.427 4.09l-.434.542c-.303.379-.718.585-1.242.617 0 0-1.893.29-3.214 3.39-1.557 3.706-.603 8.217-.646 8.271 0 0 .158.736.398 1.888.647-3.71 1.72-8.056 3.202-10.943.252-.419.65-.812 1.124-.884.465-.167.954-.051 1.407.212 0 0 2.576 1.555 11.381 1.968 1.05-.065 6.724-.41 8.617 3.863a19.716 19.716 0 0 0 1.518 2.667c.327-3.52-.051-8.023-2.962-11.855.08-.202-.39-.653-1.108-1.208ZM70.221 65.186c-.154-.119-.359-.278-.47-.451a5.996 5.996 0 0 1-1.765-4.436c.02-1.476.614-2.944 1.524-4.08.607-.758 1.648-.917 2.366-.361.718.556.805 1.588.198 2.346a3.319 3.319 0 0 0-.744 1.966c.02.805.273 1.527.845 2.058.572.53 1.318.844 2.126.769 1.668-.111 3.035-1.508 3.09-3.132-.013-.71-.214-1.393-.64-1.898-.588-.718-.435-1.74.231-2.364.76-.638 1.774-.555 2.354.07.955 1.09 1.41 2.494 1.39 3.97-.084 3.529-3 6.444-6.482 6.641-1.522.137-2.946-.264-4.023-1.098Z"
      fill="currentColor"
    />
    <path
      d="M76.146 67.732c-.832-.646-1.48-1.417-1.876-2.081a1.763 1.763 0 0 1 .626-2.367c.83-.513 1.866-.333 2.322.467.06.136 1.569 2.467 3.699 1.804 2.13-.664 4.236-.454 5.788.663 1.803 1.223 2.79 5.56 2.884 8.397.029.913-.674 1.794-1.59 1.885-.914.091-1.746-.555-1.775-1.469-.101-1.772-.58-5.269-1.507-5.9-.98-.672-2.183-.537-2.986-.27-2.278.638-4.233-.079-5.585-1.129Z"
      fill="currentColor"
    />
    <rect x={10} y={75} width={130} height={5} rx={2.5} fill="currentColor" />
    <path
      d="M117 126v7.5a2.5 2.5 0 1 1-5 0V126h5ZM38 126v7.5a2.5 2.5 0 1 1-5 0V126h5Z"
      fill="currentColor"
    />
    <path d="m27.415 60 3.5 15.5 19 .5-5.5-20H29c-2.4 0-2.085 2-1.585 4Z" fill="#6AD5E5" />
    <path
      d="M48.5 76.5h1.875l-.412-1.83-4.148-18.438A3.5 3.5 0 0 0 42.4 53.5H27.062a3.5 3.5 0 0 0-3.396 4.349l4.379 17.515.284 1.136H48.5Z"
      stroke="currentColor"
      strokeWidth={3}
    />
    <path
      d="m26.346 124.5-4.674-43h106.656l-4.674 43H26.346Z"
      fill="#E9F9FB"
      stroke="currentColor"
      strokeWidth={3}
    />
    <circle cx={74} cy={103} r={18} fill="#fff" />
    <path
      d="M70 93a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v20a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V93Z"
      fill="#FF4496"
    />
    <path
      d="M84 99a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H64a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h20Z"
      fill="#FF4496"
    />
  </svg>
);

export default SvgDoctorOfficee;
